import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from "react";
import { Group, Modal, Tabs } from "@mantine/core";
import { useAuth } from "../../../auth";
import { FollowersTab } from "./FollowersTab";
import { FollowingTab } from "./FollowingTab";
import { SuggestedTab } from "./SuggestedTab";
export var ManageFollowModalTabs;
(function (ManageFollowModalTabs) {
    ManageFollowModalTabs["FOLLOWERS"] = "followers";
    ManageFollowModalTabs["FOLLOWING"] = "following";
    ManageFollowModalTabs["SUGGESTED"] = "suggested";
})(ManageFollowModalTabs || (ManageFollowModalTabs = {}));
export const ManageFollowModal = (props) => {
    const { opened, walletAddress, initialTab = ManageFollowModalTabs.FOLLOWERS, } = props;
    const auth = useAuth();
    const finalWalletAddress = walletAddress !== null && walletAddress !== void 0 ? walletAddress : auth.walletAddress;
    if (finalWalletAddress == null) {
        return null;
    }
    if (!opened)
        return null;
    const isMine = auth.walletAddress === finalWalletAddress;
    return (_jsx(ManageFollowModalInner, { ...props, walletAddress: finalWalletAddress, isMine: isMine, initialTab: initialTab }));
};
const ManageFollowModalInner = (props) => {
    const { onClose, walletAddress, isMine, initialTab } = props;
    const [activeTab, setActiveTab] = useState(initialTab);
    return (_jsx(Modal, { zIndex: 1001, opened: true, onClose: onClose, size: "lg", withCloseButton: false, children: _jsxs(Tabs, { value: activeTab, onTabChange: (value) => setActiveTab(value), styles: (theme) => ({
                tab: {
                    fontWeight: 500,
                },
                tabsList: {
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap-reverse",
                    background: "transparent",
                    border: "none",
                    borderBottom: `1px solid ${theme.colors.divider}}`,
                },
                tabLabel: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "pre",
                    height: 20,
                },
            }), children: [_jsx(Tabs.List, { children: _jsxs(Group, { noWrap: true, w: "100%", children: [_jsx(Tabs.Tab, { value: ManageFollowModalTabs.FOLLOWERS, py: 13, w: "100%", children: isMine ? "My followers" : "Followers" }), _jsx(Tabs.Tab, { value: ManageFollowModalTabs.FOLLOWING, py: 13, w: "100%", children: "Following" }), _jsx(Tabs.Tab, { value: ManageFollowModalTabs.SUGGESTED, py: 13, w: "100%", children: "Suggested" })] }) }), _jsx(Tabs.Panel, { value: ManageFollowModalTabs.FOLLOWERS, mt: 16, children: activeTab === ManageFollowModalTabs.FOLLOWERS && (_jsx(FollowersTab, { walletAddress: walletAddress })) }), _jsx(Tabs.Panel, { value: ManageFollowModalTabs.FOLLOWING, mt: 16, children: activeTab === ManageFollowModalTabs.FOLLOWING && (_jsx(FollowingTab, { walletAddress: walletAddress })) }), _jsx(Tabs.Panel, { value: ManageFollowModalTabs.SUGGESTED, mt: 16, children: activeTab === ManageFollowModalTabs.SUGGESTED && _jsx(SuggestedTab, {}) })] }) }));
};
